export function fmtDate(dateStr, part) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const full = `${day}/${month}/${year} ${hour}:${min}`;
  if (part === 'date') {
    return full.split(' ')[0];
  } else if (part === 'time') {
    return full.split(' ')[1];
  }
  return full;
}

export function fmtDateTimezone(dateStr, part) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  // Ajusta a data para o fuso horário local (UTC-3)
  date.setHours(date.getHours() - 3);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const full = `${day}/${month}/${year} ${hour}:${min}`;  
  if (part === 'date') {
    return full.split(' ')[0];
  }
  if (part === 'time') {
    return full.split(' ')[1];
  }
  return full;
}

// #2026-02-17T15:28:39.849195-03:00